// GIF search feature API client.
// Calls GET /api/v1/gifs/search — a server-side Giphy proxy (the API key
// never reaches the browser). Types mirror api/schemas/gifs.py.
import { apiClient } from "@/lib/api-client";

export interface GifResult {
  id: string;
  title: string;
  preview_url: string;
  url: string;
  width: number;
  height: number;
}

export interface GifSearchResponse {
  results: GifResult[];
  /** False when no Giphy API key is configured yet on the backend. */
  enabled: boolean;
}

/**
 * Search (or, with no query, fetch trending) GIFs for the GIF picker.
 *
 * Requires an authenticated session cookie. Throws ApiError on 401 or
 * network errors.
 */
export async function searchGifs(query?: string): Promise<GifSearchResponse> {
  const params = new URLSearchParams();
  if (query && query.trim()) params.set("q", query.trim());
  const qs = params.toString();
  return apiClient<GifSearchResponse>(`/api/v1/gifs/search${qs ? `?${qs}` : ""}`);
}
